import { Suspense, useCallback, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'ksnm-common-ui/lib/ConfigProvider';
import ResizeObserver from 'rc-resize-observer';
import type { ReactElement } from 'react';

import { ConfirmDialog } from '@common/ConfirmDialog';
import { Preloader } from '@common/Preloader/Preloader';
import { appStore } from '@stores/appStore';
import { userStore } from '@stores/userStore';

import { AppRouter } from '../AppRouter';
import { ErrorBoundary } from '../ErrorBoundary';
import { HistoryObserver } from '../HistoryObserver';

export const App = (): ReactElement => {
  const { setDimension } = appStore;
  const { getUserInfo } = userStore;

  const onResize = useCallback(
    (dimension) => {
      setDimension(dimension);
    },
    [setDimension],
  );

  useEffect(() => {
    void (async () => {
      await getUserInfo();
    })();
  }, [getUserInfo]);

  return (
    <ResizeObserver onResize={onResize}>
      <BrowserRouter>
        <HistoryObserver>
          <ConfigProvider>
            <Suspense fallback={<Preloader />}>
              <Preloader />
              <ErrorBoundary>
                <AppRouter />
              </ErrorBoundary>
              <ConfirmDialog />
            </Suspense>
          </ConfigProvider>
        </HistoryObserver>
      </BrowserRouter>
    </ResizeObserver>
  );
};
